/** Delays the value provided until the app hydration is done, returning `undefined` before that. */

import {useHydrationDone} from '@aboutyou/lazy-imports';

export function useValueAfterHydration<Value>(
  value: Value,
): PossiblyUndefined<Value extends () => any ? ReturnType<Value> : Value> {
  const isDone = useHydrationDone();

  if (!isDone) {
    return undefined;
  }

  if (typeof value === 'function') {
    return value();
  }

  return value as Exclude<Value, () => any>;
}

type PossiblyUndefined<T> = T | undefined;
